// App dependencies
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AdminGuard, FactoringGuard } from './api/guards/admin-guard';

import { environment } from 'src/environments/environment';

const canActivate = environment.production ? [MsalGuard] : [];

const routes: Routes = [
  { path: '', redirectTo: 'tax-suite', pathMatch: 'full' },
  {
    path: `tax-suite`,
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
    data: {
      breadcrumb: 'Tax suite',
    },
    canActivate: [...canActivate],
  },
  {
    path: `tdd`,
    loadChildren: () =>
      import('./modules/tdd/tdd.module').then((m) => m.TDDModule),
    data: {
      breadcrumb: 'My projects',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'atrio',
    loadChildren: () =>
      import('./modules/atrio/atrio.module').then((m) => m.AtrioModule),
    data: {
      breadcrumb: 'Atrio',
    },
    canActivate: [...canActivate],
  },
  // disable ACR routes
  {
    path: `acr`,
    loadChildren: () =>
      import('./modules/acr/acr.module').then((m) => m.AcrModule),
    data: {
      breadcrumb: 'ACR',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'factoring',
    loadChildren: () =>
      import('./modules/factoring/factoring.module').then(
        (m) => m.FactoringModule
      ),
    data: {
      breadcrumb: 'Factoring',
    },
    canActivate: [...canActivate, FactoringGuard],
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./modules/notifications/notifications.module').then(
        (m) => m.NotificationsModule
      ),
    data: {
      breadcrumb: 'Notifications',
    },
  },
  {
    path: `payroll`,
    loadChildren: () =>
      import('./modules/payroll/payroll.module').then((m) => m.PayrollModule),
    data: {
      breadcrumb: 'Payroll Suite',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'analytics',
    loadChildren: () =>
      import('./modules/analytics/analytics.module').then(
        (m) => m.AnalyticsModule
      ),
    data: {
      breadcrumb: 'Analytics',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'support',
    children: [
      {
        path: 'workload',
        loadChildren: () =>
          import('./modules/workload/workload.module').then(
            (m) => m.WorkloadModule
          ),
        data: {
          breadcrumb: 'Cargabilidad',
        },
        canActivate: [...canActivate, AdminGuard],
      },
    ],
  },
  {
    path: 'management',
    loadChildren: () =>
      import('./modules/management/management.module').then(
        (m) => m.ManagementModule
      ),
    canActivate: [...canActivate],
  },
  {
    path: 'market-bot',
    loadChildren: () =>
      import('./modules/management/management.module').then(
        (m) => m.ManagementModule
      ),
    data: {
      breadcrumb: 'Market Bot',
    },
    canActivate: [...canActivate],
  },

  {
    path: 'cit-campaign',
    loadChildren: () =>
      import('./modules/cit-campaign/cit-campaign.module').then(
        (m) => m.CitCampaignModule
      ),
    data: {
      breadcrumb: 'CIT Campaign',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'funds-wht',
    loadChildren: () =>
      import('./modules/funds-wht/funds-wht.module').then(
        (m) => m.FundsWhtModule
      ),
    data: {
      breadcrumb: 'Funds WHT',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'management-support',
    loadChildren: () =>
      import('./modules/management-support/management-support.module').then(
        (m) => m.ManagementSupportModule
      ),
    data: {
      breadcrumb: 'Management Support',
    },
    canActivate: [...canActivate, AdminGuard],
  },
  {
    path: 'admin-support',
    loadChildren: () =>
      import('./modules/admin-support/admin-support.module').then(
        (m) => m.AdminSupportModule
      ),
    data: {
      breadcrumb: 'Management Support',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'guide',
    loadChildren: () =>
      import('./modules/guide/guide.module').then((m) => m.GuideModule),
    data: {
      breadcrumb: 'Tax suite guide',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'billing',
    loadChildren: () =>
      import('./modules/billing/billing.module').then((m) => m.BillingModule),
    data: {
      breadcrumb: 'Billing Planner',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'ccaa',
    loadChildren: () =>
      import('./modules/ccaa/ccaa.module').then((m) => m.CcaaModule),
    data: {
      breadcrumb: 'Cuentas Anuales',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'vattech-automation',
    loadChildren: () =>
      import('./modules/vattech-automation/vattech-automation.module').then(
        (m) => m.VattechAutomationModule
      ),
    data: {
      breadcrumb: 'VAT TECH Automation',
    },
    canActivate: [...canActivate],
  },
  {
    path: 'quantitative-services',
    loadChildren: () =>
      import('./modules/qs/qs.module').then((m) => m.QsModule),
    data: {
      breadcrumb: 'Quantitative Services',
    },
    canActivate: [...canActivate],
  },

  { path: '**', redirectTo: 'tax-suite' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
